var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.024,
    height: 18.025,
    viewBox: "0 0 18.024 18.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-268.501 -2048.488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.947,102.284a9.013,9.013,0,1,1,9.013-9.012,9.022,9.022,0,0,1-9.013,9.012m0-16.913a7.9,7.9,0,1,0,7.9,7.9,7.909,7.909,0,0,0-7.9-7.9",
    transform: "translate(243.564 1964.229)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.38,89.847a1.407,1.407,0,1,1-1.407-1.407,1.407,1.407,0,0,1,1.407,1.407",
    transform: "translate(244.834 1966.247)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.567,89.847A1.407,1.407,0,1,1,34.16,88.44a1.407,1.407,0,0,1,1.407,1.407",
    transform: "translate(247.336 1966.247)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,95.393c-2.513,0-4.556-1.772-4.556-3.951h1.112c0,1.566,1.545,2.839,3.444,2.839s3.447-1.274,3.447-2.839h1.112c0,2.18-2.046,3.951-4.559,3.951",
    transform: "translate(245.014 1967.696)",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smile-icon.0435bcc5d0411433d1dc20731182701b.svg";
export { ForwardRef as ReactComponent };